import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation MailPublicExecution($ids: [Integer]) {
    mailPublicExecution(ids: $ids) {
      id
    }
  }
`

export const useMailPublicExecution = () => {
  const ids = useModalData()
  const closeModal = useCloseModal()
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { client: serviceOrdersClient })

  const handleRequest = () => {
    return request({ variables: { ids } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'Links de execução enviados com sucesso' })
        closeModal()
      } else {
        notify.error({ title: 'Ocorreu um erro ao enviar os emails' })
      }
    })
  }

  return [handleRequest, state]
}
